import ClickOutside from '../../../../../themes/custom/ef2_custom/node_modules/vue-click-outside';
import parsePhoneNumber from './../../../../../themes/custom/ef2_custom/node_modules/libphonenumber-js';

export default {
    directives: {
        ClickOutside
    },

    props: ['garageEntity'],

    data() {
        return {
            cookieName: 'active-garage',
            cookieGarageEntity: null
        }
    },

    mounted() {
        if (this.hasGarageEntity) {
            this.populateCookie();
        }

        if (! this.hasGarageEntity) {
            this.cookieGarageEntity = this.$cookies.get(this.cookieName);
        }
    },

    computed: {
        activeGarage() {
            if (this.hasGarageEntity) {
                return this.garageEntity;
            }

            return this.cookieGarageEntity;
        },

        hasActiveGarage() {
            return !lodash.isNil(this.activeGarage);
        },

        hasGarageEntity() {
            return !lodash.isNil(this.garageEntity);
        },

        hasKlantenvertellen() {
            return !_.isEmpty(this.activeGarage.klantenvertellen) && this.activeGarage.klantenvertellen.averageScore !== 0;
        },

        appointmentUrl() {
            return `/form/afspraak-maken?source_entity_type=garage_entity&source_entity_id=${this.activeGarage.id}`
        },

        parsedPhonenumber() {
            if (_.isEmpty(this.activeGarage.tel)) {
                return;
            }

            return parsePhoneNumber(this.activeGarage.tel, 'NL').number;
        },

        hasPlannerUrl() {
            return ! lodash.isNil(this.activeGarage.plannerUrl);
        }
    },

    methods: {
        populateCookie() {
            this.$cookies.remove(this.cookieName);
            this.$cookies.set(this.cookieName, JSON.stringify(this.garageEntity));
        }
    }
}